export default __webpack_public_path__ + "static/media/YuliiaKravets.3bed4fee.jpg";